/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {OfferListView} from "../../offer/views/OfferListView";
const route = [
    {
        webpackEntry: "offerList",
        exclude: [rpAppPath.friendlyOfferListAbroadCountryMap],
        path: [
            rpAppPath.friendlyOfferListAbroadRegion,
            rpAppPath.friendlyOfferListAbroadCountry,
            rpAppPath.offer.list,
            rpAppPath.friendlyOfferList,
            rpAppPath.friendlyOfferListSubType,
            rpAppPath.friendlyOfferListSubFilterGeneral,
            rpAppPath.multiOfferList.base
        ],
        component: OfferListView
    }
];

(function () {
    rpClient(route);
})();
